import { BillingCreate } from "@/modules/billing/billingAccount/BillingCreate.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/billing/create")({
    component: BillingCreate,
});
